export const songs = [
  'A Day In The Life',
  "A Hard Day's Night",
  'Across The Universe',
  "All I've Got To Do",
  'All My Loving',
  'All Together Now',
  'All You Need Is Love',
  'And I Love Her',
  'And Your Bird Can Sing',
  'Another Girl',
  'Any Time At All',
  'Ask Me Why',
  "Baby You're A Rich Man",
  "Baby's In Black",
  'Back In The USSR',
  'Because',
  'Being For The Benefit Of Mr Kite!',
  'Birthday',
  'Blackbird',
  'Blue Jay Way',
  "Can't Buy Me Love",
  'Carry That Weight',
  'Christmas Time (Is Here Again)',
  'Come Together',
  'Cry Baby Cry',
  'Cry For A Shadow',
  'Day Tripper',
  'Dear Prudence',
  'Dig A Pony',
  'Dig It',
  'Do You Want To Know A Secret',
  'Doctor Robert',
  "Don't Bother Me",
  "Don't Let Me Down",
  "Don't Pass Me By",
  'Drive My Car',
  'Eight Days A Week',
  'Eleanor Rigby',
  'Every Little Thing',
  "Everybody's Got Something To Hide Except Me And My Monkey",
  'Fixing A Hole',
  'Flying',
  'For No One',
  'For You Blue',
  'Free As A Bird',
  'From Me To You',
  'Get Back',
  'Getting Better',
  'Girl',
  'Glass Onion',
  'Golden Slumbers',
  'Good Day Sunshine',
  'Good Morning Good Morning',
  'Good Night',
  'Got To Get You Into My Life',
  'Happiness Is A Warm Gun',
  'Hello, Goodbye',
  'Help!',
  'Helter Skelter',
  'Her Majesty',
  'Here Comes The Sun',
  'Here, There And Everywhere',
  'Hey Bulldog',
  'Hey Jude',
  'Hold Me Tight',
  'Honey Pie',
  'I Am The Walrus',
  'I Call Your Name',
  "I Don't Want To Spoil The Party",
  'I Feel Fine',
  'I Me Mine',
  'I Need You',
  'I Saw Her Standing There',
  'I Should Have Known Better',
  'I Wanna Be Your Man',
  'I Want To Hold Your Hand',
  'I Want To Tell You',
  "I Want You (She's So Heavy)",
  'I Will',
  "I'll Be Back",
  "I'll Cry Instead",
  "I'll Follow The Sun",
  "I'll Get You",
  "I'm A Loser",
  "I'm Down",
  "I'm Happy Just To Dance With You",
  "I'm Looking Through You",
  "I'm Only Sleeping",
  "I'm So Tired",
  "I've Got A Feeling",
  "I've Just Seen A Face",
  'If I Fell',
  'If I Needed Someone',
  'In My Life',
  "It Won't Be Long",
  "It's All Too Much",
  "It's Only Love",
  'Julia',
  'Lady Madonna',
  'Let It Be',
  'Little Child',
  'Long, Long, Long',
  'Love Me Do',
  'Love You To',
  'Lovely Rita',
  'Lucy In The Sky With Diamonds',
  'Magical Mystery Tour',
  'Martha My Dear',
  "Maxwell's Silver Hammer",
  'Mean Mr Mustard',
  'Michelle',
  'Misery',
  "Mother Nature's Son",
  'No Reply',
  'Norwegian Wood (This Bird Has Flown)',
  'Not A Second Time',
  'Now And Then',
  'Nowhere Man',
  'Ob-La-Di, Ob-La-Da',
  "Octopus's Garden",
  'Oh! Darling',
  'Old Brown Shoe',
  'One After 909',
  'Only A Northern Song',
  'Paperback Writer',
  'Penny Lane',
  'Piggies',
  'Please Please Me',
  'Polythene Pam',
  'PS I Love You',
  'Rain',
  'Real Love',
  'Revolution',
  'Revolution 1',
  'Revolution 9',
  'Rocky Raccoon',
  'Run For Your Life',
  'Savoy Truffle',
  'Sexy Sadie',
  "Sgt Pepper's Lonely Hearts Club Band",
  "Sgt Pepper's Lonely Hearts Club Band (Reprise)",
  'She Came In Through The Bathroom Window',
  'She Loves You',
  'She Said She Said',
  "She's A Woman",
  "She's Leaving Home",
  'Something',
  'Strawberry Fields Forever',
  'Sun King',
  'Taxman',
  'Tell Me What You See',
  'Tell Me Why',
  'Thank You Girl',
  'The Ballad Of John And Yoko',
  'The Continuing Story Of Bungalow Bill',
  'The End',
  'The Fool On The Hill',
  'The Inner Light',
  'The Long And Winding Road',
  'The Night Before',
  'The Word',
  "There's A Place",
  'Things We Said Today',
  'Think For Yourself',
  'This Boy',
  'Ticket To Ride',
  'Tomorrow Never Knows',
  'Two Of Us',
  'Wait',
  'We Can Work It Out',
  'What Goes On',
  "What You're Doing",
  'When I Get Home',
  "When I'm Sixty-Four",
  'While My Guitar Gently Weeps',
  "Why Don't We Do It In The Road?",
  'Wild Honey Pie',
  'With A Little Help From My Friends',
  'Within You Without You',
  'Yellow Submarine',
  'Yer Blues',
  'Yes It Is',
  'Yesterday',
  "You Can't Do That",
  'You Know My Name (Look Up The Number)',
  'You Like Me Too Much',
  'You Never Give Me Your Money',
  "You Won't See Me",
  "You're Going To Lose That Girl",
  "You've Got To Hide Your Love Away",
  'Your Mother Should Know',
] as const;
